import * as React from 'react';
import * as PropTypes from 'prop-types';

function OtherBuyersWithListingInCart(props) {
  return (
    <p className="in-demand-tag">
      <span className="in-demand-tag__title">
        {I18n.t('js.listings.dontMissOut')}
      </span>
      <br />
      {I18n.t('js.listings.peopleHaveInCarts', { count: props.otherBuyersWithListingInCartCount })}
    </p>
  );
}

OtherBuyersWithListingInCart.propTypes = {
  otherBuyersWithListingInCartCount: PropTypes.string.isRequired,
};

export default OtherBuyersWithListingInCart;



// WEBPACK FOOTER //
// ./javascripts/components/listings/other_buyers_with_listing_in_cart.jsx